// https://www.tes.com/styleguide#colours
// colours as used by TES brand

const colours = {
    product: {
        red: '#e1665c',
        apricot: '#E87C73',
        hitPink: '#FBA68B',
        blue: '#498af4',
        green: '#97bf78',
        purple: '#724c98',
        coral: '#fb8666',
        emerald: '#0eb69c'
    },
    crimsonLight: '#ff5763', 
    crimson: '#fd3753',
    crimsonDark: '#ea1848',
    cyanLight: '#64b3f8',
    cyan: '#44a4f6',
    cyanDark: '#2189e2',
    limeLight: '#9ec94d',
    lime: '#82bb25',
    limeDark: '#76b021',
    orangeLight: '#fe864c',
    orange: '#fd7037',
    orangeDark: '#eb612a',
    lilacLight: '#b382c8',
    lilac: '#ab6dc5',
    lilacDark: '#985bb2',
    yellowLight: '#ffdb44',
    yellow: '#ffd014',
    yellowDark: '#f2c00c',
    grey1: '#f5f5f5',
    grey2: '#ebebeb',
    grey3: '#d2d6d9',
    grey4: '#b3b8bd',
    grey5: '#5c656e',
    grey6: '#3e474f',
    grey7: '#2f3840',
    grey8: '#231f20',
    white: '#FFFFFF',
    black: '#000000'
};

export default colours;


